module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"qbo":{"title":"QuickBooks online","invoices":"Sync your contacts and invoices","connected":"Connected"}}}')
  delete Component.options._Ctor
}
